import Typograf from 'typograf';

export const typograf = new Typograf({ locale: ['ru', 'en-US'] });

export const handTypograf = (text: string): string => {
  let typografedText = text
    .trim()
    // убирать пробелы в начале строки
    .replace(/^\s+/gm, '')
    // Первая буква - заглавная
    .replace(/^\W*?[а-яёА-ЯЁ]/g, (text) => {
      return text.toUpperCase();
    })
    // Буква после .!? - заглавная
    .replace(/([.!?][^А-ЯЁ]*?)([а-яё])/g, (text) => {
      return text.toUpperCase();
    })
    // .?!,;:'"`() - не больше одного символа подряд
    .replace(/([.!?,;:'"`()\s])\1+/g, '$1')
    // удаляю пробел в датах
    .replace(/(\d{1,2}\.) ?(\d{1,2}\.) ?(\d{2})/g, '$1$2$3')
    // добавляю пробел знаков )!?,;
    .replace(/([)!?;])(\S)/g, '$1 $2')
    // добавляю пробел после точки, за исключением дат
    .replace(/([^(\d{1,2})])\.(?=\S)/g, '$1. ')
    // добавляю пробел после запятой, за исключением чисел
    .replace(/(\D|\d),(?=\S)(?!\d)/g, '$1, ')
    // добавляю пробел между запятой и цифрой "застолье ,7 гостей"
    .replace(/(\D)(,)(\d+)/g, '$1, $3')
    // добавляю пробел после двоеточия, за исключением времени
    .replace(/([^(\d{1,2})])(:)(?=\S)(?!\d{2})/g, '$1: ')
    // добавляю пробел перед скобкой
    .replace(/(\S)\(/g, '$1 (')
    // привожу в норму "и т. Д. И т. П."
    .replace(/и т. Д. И т. П./g, 'и т.д. и т.п.');

  const result = [];

  let quoteNumber = {};
  // добавляю пробел до открывающей кавычки и пробел после закрывающей
  Array.from(typografedText).forEach((symbol, idx) => {
    if (['"', "'"].includes(symbol)) {
      quoteNumber[symbol] = (quoteNumber[symbol] ?? 0) + 1;

      if (quoteNumber[symbol] % 2 === 1) {
        result.push(idx === 0 ? symbol : [' ', symbol]);
        return;
      }

      if (result[result.length - 1] === ' ') {
        result.pop();
      }
      result.push([symbol, ' ']);
      return;
    }

    result.push(symbol);
  });

  // @ts-ignore
  return result.flat().join('');
};
